"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var initialState = {
  started: false,
  completed: false,
  inviteReset: false,
  //results: [],
  results: [
    /*{
      question_id: 4,
      response_id: [1, 3]
    }*/
  ],
  currentQuestionnaireID: "",
  currentQuestion: {},
  currentResult: {},
  globalScore: 0
};
var _default = initialState;
exports["default"] = _default;